import { toast } from "react-toastify";
import { RepositoryFactory } from "repository/RepositoryFactory";

const waitlist = RepositoryFactory.get("waitlist");

export const getWaitlistedUsers = (page, limit) => async (dispatch) => {
  try {
    dispatch({ type: "GET_WAITLIST_LOADER", payload: true });

    const { data } = await waitlist.getWaitlistedUsers(page, limit);
    
    console.log('Get all response:', data);
    
    dispatch({
      type: "GET_WAITLISTED_USERS",
      payload: {
        users: data.data?.users || data.data || [],
        totalPages: data.data?.totalPages || data.totalPages || 1
      }
    });
    dispatch({ type: "GET_WAITLIST_LOADER", payload: false });
  } catch (err) {
    console.error('Get all error:', err);
    toast.error(err.response?.data?.message || "Failed to fetch waitlisted users");
    dispatch({ type: "GET_WAITLIST_LOADER", payload: false });
  }
};

export const searchWaitlistedUsers = (query, page, statusFilter = "all") => async (dispatch) => {
  try {
    dispatch({ type: "GET_WAITLIST_LOADER", payload: true });

    const { data } = await waitlist.searchWaitlistedUsers(query, page);
    
    console.log('Search response:', data);
    
    if (data?.success) {
      let filteredUsers = data.data || [];
      
      console.log('Total search results:', filteredUsers.length);
      
      // Filter for service-provider role only
      filteredUsers = filteredUsers.filter(user => user.role === "service-provider");
      console.log('After service-provider filter:', filteredUsers.length);
      
      // Apply client-side filtering based on statusFilter
      if (statusFilter === "waitlisted") {
        filteredUsers = filteredUsers.filter(user => user.waitlisted === true);
        console.log('After waitlisted filter:', filteredUsers.length);
      } else if (statusFilter === "active") {
        filteredUsers = filteredUsers.filter(user => user.waitlisted === false);
        console.log('After active filter:', filteredUsers.length);
      }
      
      dispatch({
        type: "SEARCH_WAITLISTED_USERS",
        payload: {
          data: filteredUsers,
          totalPages: data.totalPages || 1
        },
      });
    } else {
      console.error('Search failed:', data);
      toast.error("Search failed");
    }
    dispatch({ type: "GET_WAITLIST_LOADER", payload: false });
  } catch (err) {
    console.error('Search error:', err);
    toast.error(err.response?.data?.message || "Failed to search waitlisted users");
    dispatch({ type: "GET_WAITLIST_LOADER", payload: false });
  }
};

export const filterWaitlistedUsers = (statusFilter, page) => async (dispatch) => {
  try {
    dispatch({ type: "GET_WAITLIST_LOADER", payload: true });

    // For "all", just get all waitlisted users
    if (statusFilter === "all") {
      const { data } = await waitlist.getWaitlistedUsers(page, 10);
      console.log('Filter (all) response:', data);
      
      dispatch({
        type: "FILTER_WAITLISTED_USERS",
        payload: {
          data: data.data?.users || data.data || [],
          totalPages: data.data?.totalPages || data.totalPages || 1
        },
      });
    } else {
      // For specific filters, get all users and filter client-side
      const { data } = await waitlist.getWaitlistedUsers(1, 1000); // Get more results
      console.log('Filter response:', data);
      
      let allUsers = data.data?.users || data.data || [];
      console.log('Total users before filter:', allUsers.length);
      
      let filteredUsers = [];
      
      if (statusFilter === "waitlisted") {
        filteredUsers = allUsers.filter(user => user.waitlisted === true);
        console.log('Waitlisted users:', filteredUsers.length);
      } else if (statusFilter === "active") {
        filteredUsers = allUsers.filter(user => user.waitlisted === false);
        console.log('Active users:', filteredUsers.length);
      }
      
      dispatch({
        type: "FILTER_WAITLISTED_USERS",
        payload: {
          data: filteredUsers,
          totalPages: 1 // Client-side filtering
        },
      });
    }
    
    dispatch({ type: "GET_WAITLIST_LOADER", payload: false });
  } catch (err) {
    console.error('Filter error:', err);
    toast.error(err.response?.data?.message || "Failed to filter waitlisted users");
    dispatch({ type: "GET_WAITLIST_LOADER", payload: false });
  }
};

export const activateWaitlistedUser =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "WAITLIST_ACTION_LOADER", payload: true });

      const { data } = await waitlist.activateWaitlistedUser(id);
      toast.success(data?.message || "User account activated successfully");
      
      dispatch({
        type: "ACTIVATE_WAITLISTED_USER",
        payload: id,
      });
      
      onSuccess();
      dispatch({ type: "WAITLIST_ACTION_LOADER", payload: false });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to activate user");
      dispatch({ type: "WAITLIST_ACTION_LOADER", payload: false });
    }
  };

export const deleteWaitlistedUser =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "WAITLIST_ACTION_LOADER", payload: true });

      const { data } = await waitlist.deleteWaitlistedUser(id);
      toast.success(data?.message || "User account deleted successfully");
      
      dispatch({
        type: "DELETE_WAITLISTED_USER",
        payload: id,
      });
      
      onSuccess();
      dispatch({ type: "WAITLIST_ACTION_LOADER", payload: false });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete user");
      dispatch({ type: "WAITLIST_ACTION_LOADER", payload: false });
    }
  };
